<template>
    <div class="table-cell" v-bind:class="classes">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table-cell',

        props: {
            header: {
                default: false
            },
            footer: {
                default: false
            },
            responsive: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            classes() {
                return {
                    'table-cell--header': this.header,
                    'table-cell--footer': this.footer,
                    'table-cell-responsive': this.responsive
                };
            }
        }
    }
</script>

<style lang="scss">
    .table-cell {
        @apply .align-middle .p-4 .table-cell;

        border-top: 1px solid #e0e0e0;
        
        &--header {
            border-bottom: 1px solid #e0e0e0;
        }
        &--footer {
            border-top: 2px solid #e0e0e0;
        }
        &--right {
            @apply .text-right;
        }
        &__link {
            @apply .text-blue .inline-block .align-middle .ml-2;

            &:hover {
                @apply .text-orange;
                
            }
            &--delete {
                @apply .text-red; 
            }
            svg {
                @apply .text-lg;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/table/Cell.vue